import React, {useEffect, useState} from 'react';
import {Link, useParams} from 'react-router-dom';
import {getOrder} from '../api';
import './OrderPage.css';

const formatPrice = (price) => `${Number(price).toLocaleString('ru-RU')} руб.`;

function OrderPage() {
    const token = localStorage.getItem('token');
    const {orderId} = useParams();
    const [orderData, setOrderData] = useState(null);
    const [message, setMessage] = useState('');

    const fetchOrder = async () => {
        setMessage('');
        const data = await getOrder(token, orderId);

        if (data.order_id) {
            setOrderData(data);
        } else {
            setMessage(data.message || 'Заказ не найден');
        }
    };

    useEffect(() => {
        fetchOrder();
        // eslint-disable-next-line
    }, [orderId]);

    if (message) {
        return (
            <section className="page order-page">
                <div className="notice notice-error">{message}</div>
            </section>
        );
    }

    if (!orderData) {
        return (
            <section className="page order-page">
                <div className="panel empty-state">Загрузка данных заказа...</div>
            </section>
        );
    }

    const itemCount = orderData.items.reduce((sum, item) => sum + Number(item.quantity || 0), 0);

    return (
        <section className="page order-page" data-testid="order-page">
            <header className="page-header order-header">
                <div>
                    <p className="page-kicker">Заказ</p>
                    <h1 className="page-title">Заказ №{orderData.order_id}</h1>
                    <p className="page-subtitle">Детали покупки и состав заказа.</p>
                </div>
                <Link to="/orders" className="btn btn-muted order-history-link">
                    Все заказы
                </Link>
            </header>

            <div className="order-summary panel">
                <div className="order-summary-item">
                    <span>Дата оформления</span>
                    <strong>{orderData.created_at}</strong>
                </div>
                <div className="order-summary-item">
                    <span>Товары</span>
                    <strong>{itemCount}</strong>
                </div>
                <div className="order-summary-item">
                    <span>Сумма</span>
                    <strong>{formatPrice(orderData.total_price)}</strong>
                </div>
            </div>

            <div className="order-table-card panel">
                <div className="order-table-header">
                    <h2>Состав заказа</h2>
                </div>
                <div className="order-table-scroll">
                    <table className="order-table">
                        <thead>
                        <tr>
                            <th>Название</th>
                            <th>Бренд</th>
                            <th>Цена</th>
                            <th>Кол-во</th>
                            <th>Итого</th>
                        </tr>
                        </thead>
                        <tbody>
                        {orderData.items.map((item, idx) => (
                            <tr key={`${item.item_id || item.name}-${idx}`}>
                                <td>{item.name}</td>
                                <td>{item.brand}</td>
                                <td>{formatPrice(item.price)}</td>
                                <td>{item.quantity}</td>
                                <td>{formatPrice(Number(item.price) * Number(item.quantity))}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </section>
    );
}

export default OrderPage;
